// ReviewPageSkeleton.jsx — traces the head / context / rating / comment
// rhythm of reviewPage.js so the page doesn't jump when data lands.
import React from "react";
import "./reviewPageSkeleton.css";

const ReviewPageSkeleton = () => {
	return (
		<div className="sf-skel-review">
			<div className="sf-skel-review-wrap">
				{/* HEAD */}
				<div className="sf-skel-review-head">
					<div className="sf-skel-review-pill shimmer"></div>
					<div className="sf-skel-review-eyebrow shimmer"></div>
					<div className="sf-skel-review-line sf-skel-review-title w-60 shimmer"></div>
				</div>

				{/* CONTEXT CARD */}
				<div className="sf-skel-review-context">
					<div className="sf-skel-review-avatar shimmer"></div>
					<div className="sf-skel-review-stack">
						<div className="sf-skel-review-line w-50 shimmer"></div>
						<div className="sf-skel-review-line sf-skel-review-tiny w-70 shimmer"></div>
					</div>
					<div className="sf-skel-review-chips">
						<div className="sf-skel-review-chip shimmer"></div>
						<div className="sf-skel-review-chip shimmer"></div>
					</div>
				</div>

				{/* RATING HERO */}
				<div className="sf-skel-review-rating">
					<div className="sf-skel-review-line sf-skel-review-big w-50 shimmer"></div>
					<div className="sf-skel-review-stars">
						{Array.from({ length: 5 }).map((_, i) => (
							<div className="sf-skel-review-star shimmer" key={i}></div>
						))}
					</div>
					<div className="sf-skel-review-line sf-skel-review-tiny w-30 shimmer"></div>
				</div>

				{/* COMMENT */}
				<div className="sf-skel-review-comment">
					<div className="sf-skel-review-line sf-skel-review-tiny w-40 shimmer"></div>
					<div className="sf-skel-review-textarea shimmer"></div>
				</div>

				{/* SUBMIT */}
				<div className="sf-skel-review-submit shimmer"></div>
			</div>
		</div>
	);
};

export default ReviewPageSkeleton;
